define('controllers/vspcalculator',['require'],function(require) {
    return function() {
        var annualSavings = $("#annualSavings"),
                txtAmount = $("#txtAmount");

        txtAmount.on("keyup", function () {
            var total = roundNumber(txtAmount.val() * (window.ServerData.feData.planPercentage + 1), 2);
            annualSavings.text(total);
        });
    };
});
